// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Comment-Box .comment-section.inactive {
  display: none;
}
.Comment-Box .comment-section.active {
  display: block;
}
.Comment-Box .comment-section #chat-circle {
  position: fixed;
  bottom: 50px;
  right: 50px;
  background: var(--color-maersk-blue);
  width: 65px;
  height: 65px;
  border-radius: 50%;
  color: var(--color-white);
  padding: 22px;
  z-index: 9;
  cursor: pointer;
  box-shadow: 0px 3px 16px 0px rgba(0, 0, 0, 0.6), 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
  opacity: 0.65;
}
.Comment-Box .comment-section #chat-circle:hover {
  opacity: 1;
  color: var(--color-white);
}
.Comment-Box .comment-section .btn#my-btn {
  background: var(--color-white);
  padding-top: 13px;
  padding-bottom: 12px;
  border-radius: 45px;
  padding-right: 40px;
  padding-left: 40px;
  color: #5865c3;
}
.Comment-Box .comment-section #chat-overlay {
  background: rgba(255, 255, 255, 0.1);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  display: none;
}
.Comment-Box .comment-section .show-chatbox {
  display: block !important;
  transition: 1s ease-in-out;
}
.Comment-Box .comment-section .chat-box {
  display: none;
  background: #fff;
  position: fixed;
  right: 30px;
  bottom: 50px;
  width: 600px;
  max-width: 85vw;
  max-height: 78vh;
  border-radius: 5px;
  box-shadow: 0px 5px 35px 9px var(--chat-box-border-color);
  z-index: 99;
}
.Comment-Box .comment-section .chat-box-expand {
  width: 900px;
  max-width: 100vw;
  max-height: 100vh;
}
.Comment-Box .comment-section .chat-box-toggle {
  margin-right: 15px;
  cursor: pointer;
}
.Comment-Box .comment-section .chat-box-header {
  background: var(--color-maersk-blue);
  height: 49px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  color: var(--color-white);
  text-align: center;
  font-size: var(--font-size-md);
  padding-top: 12px;
  font-weight: 500;
}
.Comment-Box .comment-section .chat-box-body {
  position: relative;
  height: auto;
  overflow: auto;
  padding: 8px;
}
.Comment-Box .comment-section .chat-box-body:after {
  content: "";
  opacity: 0.1;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  height: 100%;
  position: absolute;
  z-index: -1;
}
.Comment-Box .comment-section #chat-input {
  font-size: 14px;
  resize: none;
  overflow: hidden;
}
.Comment-Box .comment-section #chat-input.overflow {
  overflow-y: auto; /* Add scrollbar when overflow */
  max-height: 100px; /* Maximum height before scroll is needed */
}
.Comment-Box .comment-section .chat-input > form {
  margin-bottom: 0;
}
.Comment-Box .comment-section #chat-input::-webkit-input-placeholder {
  color: var(--chat-box-border-color);
}
.Comment-Box .comment-section #chat-input::-moz-placeholder {
  color: var(--chat-box-border-color);
}
.Comment-Box .comment-section #chat-input:-ms-input-placeholder {
  color: var(--chat-box-border-color);
}
.Comment-Box .comment-section #chat-input:-moz-placeholder {
  color: var(--chat-box-border-color);
}
.Comment-Box .comment-section .button-wrapper {
  white-space: nowrap;
}
.Comment-Box .comment-section .button-wrapper .button {
  height: 32px;
}
.Comment-Box .comment-section .close-msg-icon {
  cursor: pointer;
  padding: 4px;
  margin-right: 5px;
  margin-bottom: 3px;
  float: right;
  border: 1px solid #fff;
  color: var(--color-black);
  background-color: #fff;
}
.Comment-Box .comment-section .expand-btn {
  margin-left: 0px;
}
.Comment-Box .comment-section .expand-btn .button-wrapper {
  white-space: nowrap;
}
.Comment-Box .comment-section .expand-btn .button-wrapper .button {
  height: 32px;
}
.Comment-Box .comment-section .expand-icon {
  cursor: pointer;
  padding: 4px;
  border: 1px solid #fff;
  color: black;
  background-color: #fff;
  border-radius: 3px;
  border-color: rgb(207, 207, 207);
}
.Comment-Box .comment-section .chat-submit {
  position: absolute;
  bottom: 12px;
  right: 4px;
  background: transparent;
  box-shadow: none;
  border: none;
  border-radius: 50%;
  color: var(--color-maersk-blue);
}
.Comment-Box .comment-section .chat-submit.disabled {
  opacity: 0.5;
}
.Comment-Box .comment-section .chat-submit .message-send-icon:hover {
  color: #5865c3;
}
.Comment-Box .comment-section .chat-logs {
  padding: 0;
  height: 300px;
}
.Comment-Box .comment-section .chat-logs .chat-msg {
  margin-bottom: 5px;
}
.Comment-Box .comment-section .chat-logs .chat-msg .chat-text-div {
  display: flex;
}
.Comment-Box .comment-section .chat-logs .chat-msg .timestamp {
  float: right;
  font-size: 12px;
  padding: 5px 10px;
  color: black;
}
.Comment-Box .comment-section .chat-logs .chat-msg .user-name {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.Comment-Box .comment-section .chat-logs .chat-msg .user-details {
  display: flex;
}
.Comment-Box .comment-section .chat-logs .chat-msg .user-details .user-icon {
  width: 40.79px;
  height: 40px;
  gap: 0px;
  border-radius: 100px 0px 0px 0px;
  opacity: 0px;
}
.Comment-Box .comment-section .chat-logs .chat-msg .user-name-details {
  font-weight: 400;
  text-align: start;
  font-size: 12px;
  display: flex;
  flex-direction: column;
  margin-left: 5px;
}
.Comment-Box .comment-section .chat-logs .chat-msg .user-name-details .user-name-display {
  font-size: var(--font-size-md);
  font-weight: 700;
  line-height: 24px;
}
.Comment-Box .comment-section .chat-logs .chat-msg .details {
  font-size: 12px;
  margin-left: 35px;
  color: #999;
}
.Comment-Box .comment-section .chat-logs .chat-msg .details .time {
  margin-left: 7rem;
}
.Comment-Box .comment-section .chat-logs .chat-msg .user-chat {
  align-items: center;
  line-height: 1.75;
  display: inline-flex;
  width: 100%;
  border-radius: 3px;
  white-space: pre-wrap;
  font-weight: 400;
  font-size: var(--font-size-md);
  overflow-wrap: anywhere;
}
.Comment-Box .comment-section .chat-logs-expand {
  height: 380px;
}
.Comment-Box .comment-section .chat-logs::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #f5f5f5;
}
.Comment-Box .comment-section .chat-logs::-webkit-scrollbar {
  width: 5px;
  background-color: #f5f5f5;
}
.Comment-Box .comment-section .chat-logs::-webkit-scrollbar-thumb {
  background-color: #5a5eb9;
}
@media only screen and (max-width: 500px) {
  .Comment-Box .comment-section .chat-logs {
    height: 40vh;
  }
}
.Comment-Box .comment-section .cm-msg-text {
  background: white;
  padding: 10px 15px 10px 15px;
  color: #666;
  max-width: 75%;
  float: left;
  margin-left: 10px;
  position: relative;
  margin-bottom: 20px;
  border-radius: 30px;
}
.Comment-Box .comment-section .chat-msg {
  clear: both;
}
.Comment-Box .comment-section .chat-msg.self > .cm-msg-text {
  float: right;
  margin-right: 10px;
  background: #5a5eb9;
  color: var(--color-white);
}
.Comment-Box .comment-section .cm-msg-button > ul > li {
  list-style: none;
  float: left;
  width: 50%;
}
.Comment-Box .comment-section .cm-msg-button {
  clear: both;
  margin-bottom: 70px;
}
.Comment-Box .comment-section .editSection {
  display: flex;
  border-radius: 3px;
  font-weight: 400;
  font-size: var(--font-size-md);
  line-height: 24px;
}
.Comment-Box .comment-section .editSection span {
  margin-left: 2px;
  padding: 2px;
  cursor: pointer;
}
.Comment-Box .comment-section .message {
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;
}
.Comment-Box .comment-section .hkNbke {
  border: solid 1px var(--table-input-border-color) !important;
  border-bottom: solid 2px #0dcaf0 !important;
}
.Comment-Box .comment-section .comment-editors {
  display: flex;
  align-items: center;
  background-color: #f9f9f9;
  padding: 5px;
  border-radius: 5px;
}
.Comment-Box .comment-section .comment-editors .text-area-comment {
  flex: 1 1;
  padding: 2px;
  border-radius: 4px;
  outline: none;
}
.Comment-Box .comment-section .comment-editors .hkNbke {
  border: solid 1px var(--table-input-border-color) !important;
  border-bottom: solid 2px #0dcaf0 !important;
}
.Comment-Box .comment-section .edit-icon {
  color: var(--color-maersk-blue);
  cursor: pointer;
}
.Comment-Box .comment-section .edit-icon .edit-image {
  height: 18px;
}
.Comment-Box .comment-section .notes-button {
  margin-top: -3px;
}
.Comment-Box .comment-section .edit-icon :hover {
  color: #466b77;
}`, "",{"version":3,"sources":["webpack://./src/pages/DtcoOverviewPage/DtcoComment/DtcoComment.scss"],"names":[],"mappings":"AAEI;EACE,aAAA;AADN;AAII;EACE,cAAA;AAFN;AAKI;EACE,eAAA;EACA,YAAA;EACA,WAAA;EACA,oCAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,UAAA;EACA,eAAA;EACA,mHAAA;EAEE,aAAA;AAJR;AAMI;EACE,UAAA;EACA,yBAAA;AAJN;AAOI;EACE,8BAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;AALN;AAQI;EACE,oCAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;AANN;AASI;EACE,yBAAA;EACA,0BAAA;AAPN;AAUI;EACE,aAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yDAAA;EACA,WAAA;AARN;AAWI;EACE,YAAA;EACA,gBAAA;EACA,iBAAA;AATN;AAYI;EACE,kBAAA;EACA,eAAA;AAVN;AAaI;EACE,oCAAA;EACA,YAAA;EACA,2BAAA;EACA,4BAAA;EACA,yBAAA;EACA,kBAAA;EACA,8BAAA;EACA,iBAAA;EACA,gBAAA;AAXN;AAcI;EACE,kBAAA;EACA,YAAA;EACA,cAAA;EACA,YAAA;AAZN;AAeI;EACE,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;AAbN;AAgBI;EACE,eAAA;EACA,YAAA;EACA,gBAAA;AAdN;AAgBK;EACC,gBAAA,EAAA,gCAAA;EACA,iBAAA,EAAA,2CAAA;AAdN;AAiBI;EACE,gBAAA;AAfN;AAkBI;EACE,mCAAA;AAhBN;AAmBI;EACE,mCAAA;AAjBN;AAoBI;EACE,mCAAA;AAlBN;AAqBI;EACE,mCAAA;AAnBN;AAqBI;EACE,mBAAA;AAnBN;AAoBM;EACE,YAAA;AAlBR;AAqBI;EACE,eAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,sBAAA;EACA,yBAAA;EACA,sBAAA;AAnBN;AAqBI;EACE,gBAAA;AAnBN;AAoBO;EACC,mBAAA;AAlBR;AAmBQ;EACE,YAAA;AAjBV;AAsBI;EACE,eAAA;EACA,YAAA;EACA,sBAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,gCAAA;AApBN;AAuBI;EACE,kBAAA;EACA,YAAA;EACA,UAAA;EACA,uBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,+BAAA;AArBN;AAuBM;EACE,YAAA;AArBR;AAwBM;EACE,cAAA;AAtBR;AA0BI;EACE,UAAA;EACA,aAAA;AAxBN;AA0BM;EACE,kBAAA;AAxBR;AA0BQ;EACE,aAAA;AAxBV;AA2BQ;EACE,YAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;AAzBV;AA4BQ;EACE,aAAA;EACA,8BAAA;EACA,WAAA;AA1BV;AA4BQ;EACE,aAAA;AA1BV;AA2BU;EACE,cAAA;EACA,YAAA;EACA,QAAA;EACA,gCAAA;EACA,YAAA;AAzBZ;AA6BQ;EACE,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AA3BV;AA4BU;EACE,8BAAA;EACA,gBAAA;EACA,iBAAA;AA1BZ;AA8BQ;EACE,eAAA;EACA,iBAAA;EACA,WAAA;AA5BV;AA6BU;EACE,iBAAA;AA3BZ;AA+BQ;EACE,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,gBAAA;EACA,8BAAA;EACA,uBAAA;AA7BV;AAkCI;EACE,aAAA;AAhCN;AAmCI;EACE,oDAAA;EACA,yBAAA;AAjCN;AAoCI;EACE,UAAA;EACA,yBAAA;AAlCN;AAqCI;EACE,yBAAA;AAnCN;AAsCI;EACE;IACE,YAAA;EApCN;AACF;AAuCI;EACE,iBAAA;EACA,4BAAA;EACA,WAAA;EACA,cAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;AArCN;AAwCI;EACE,WAAA;AAtCN;AAyCI;EACE,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;AAvCN;AA0CI;EACE,gBAAA;EACA,WAAA;EACA,UAAA;AAxCN;AA2CI;EACE,WAAA;EACA,mBAAA;AAzCN;AA4CI;EACE,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,8BAAA;EACA,iBAAA;AA1CN;AA2CM;EACE,gBAAA;EACA,YAAA;EACA,eAAA;AAzCR;AA6CI;EACE,aAAA;EACA,8BAAA;EACA,kBAAA;AA3CN;AA8CI;EACE,4DAAA;EACA,2CAAA;AA5CN;AA+CI;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;AA7CN;AA+CM;EACE,SAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;AA7CR;AAgDM;EACE,4DAAA;EACA,2CAAA;AA9CR;AAmDI;EACE,+BAAA;EACA,eAAA;AAjDN;AAkDM;EACE,YAAA;AAhDR;AAmDI;EACE,gBAAA;AAjDN;AAoDI;EACE,cAAA;AAlDN","sourcesContent":[".Comment-Box {\n  .comment-section {\n    &.inactive {\n      display: none;\n    }\n\n    &.active {\n      display: block;\n    }\n\n    #chat-circle {\n      position: fixed;\n      bottom: 50px;\n      right: 50px;\n      background: var(--color-maersk-blue);\n      width: 65px;\n      height: 65px;\n      border-radius: 50%;\n      color: var( --color-white);\n      padding: 22px;\n      z-index: 9;\n      cursor: pointer;\n      box-shadow: 0px 3px 16px 0px rgba(0, 0, 0, 0.6),\n        0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12);\n        opacity: 0.65;\n    }\n    #chat-circle:hover {\n      opacity: 1;\n      color: var(--color-white);\n    }\n\n    .btn#my-btn {\n      background: var(--color-white);\n      padding-top: 13px;\n      padding-bottom: 12px;\n      border-radius: 45px;\n      padding-right: 40px;\n      padding-left: 40px;\n      color: #5865c3;\n    }\n\n    #chat-overlay {\n      background: rgba(255, 255, 255, 0.1);\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      border-radius: 50%;\n      display: none;\n    }\n\n    .show-chatbox {\n      display: block !important;\n      transition: 1s ease-in-out;\n    }\n\n    .chat-box {\n      display: none;\n      background: #fff;\n      position: fixed;\n      right: 30px;\n      bottom: 50px;\n      width: 600px;\n      max-width: 85vw;\n      max-height: 78vh;\n      border-radius: 5px;\n      box-shadow: 0px 5px 35px 9px var(--chat-box-border-color);\n      z-index: 99;\n    }\n\n    .chat-box-expand {\n      width: 900px;\n      max-width: 100vw;\n      max-height: 100vh;\n    }\n\n    .chat-box-toggle {\n      margin-right: 15px;\n      cursor: pointer;\n    }\n\n    .chat-box-header {\n      background: var(--color-maersk-blue);\n      height: 49px;\n      border-top-left-radius: 5px;\n      border-top-right-radius: 5px;\n      color: var(--color-white);\n      text-align: center;\n      font-size: var(--font-size-md);\n      padding-top: 12px;\n      font-weight: 500;\n    }\n\n    .chat-box-body {\n      position: relative;\n      height: auto;\n      overflow: auto;\n      padding: 8px;\n    }\n\n    .chat-box-body:after {\n      content: \"\";\n      opacity: 0.1;\n      top: 0;\n      left: 0;\n      bottom: 0;\n      right: 0;\n      height: 100%;\n      position: absolute;\n      z-index: -1;\n    }\n\n    #chat-input {\n      font-size: 14px;\n      resize: none;\n      overflow: hidden;\n    }\n     #chat-input.overflow {\n      overflow-y: auto; /* Add scrollbar when overflow */\n      max-height: 100px; /* Maximum height before scroll is needed */\n    }\n  \n    .chat-input>form {\n      margin-bottom: 0;\n    }\n\n    #chat-input::-webkit-input-placeholder {\n      color: var(--chat-box-border-color);\n    }\n\n    #chat-input::-moz-placeholder {\n      color: var(--chat-box-border-color);\n    }\n\n    #chat-input:-ms-input-placeholder {\n      color: var(--chat-box-border-color);\n    }\n\n    #chat-input:-moz-placeholder {\n      color: var(--chat-box-border-color);\n    }\n    .button-wrapper {\n      white-space: nowrap;\n      .button{\n        height: 32px;\n      }\n    }\n    .close-msg-icon {\n      cursor: pointer;\n      padding: 4px;\n      margin-right: 5px;\n      margin-bottom: 3px;\n      float: right;\n      border: 1px solid #fff;\n      color: var(--color-black);\n      background-color: #fff;\n    }\n    .expand-btn{\n      margin-left: 0px;\n       .button-wrapper {\n        white-space: nowrap;\n        .button{\n          height: 32px;\n        }\n      } \n    }\n   \n    .expand-icon{\n      cursor: pointer;\n      padding: 4px;\n      border: 1px solid #fff;\n      color: black;\n      background-color: #fff;\n      border-radius: 3px;\n      border-color: rgb(207, 207, 207);\n    }\n\n    .chat-submit {\n      position: absolute;\n      bottom: 12px;\n      right: 4px;\n      background: transparent;\n      box-shadow: none;\n      border: none;\n      border-radius: 50%;\n      color: var(--color-maersk-blue);\n\n      &.disabled {\n        opacity: 0.5;\n      }\n     \n      .message-send-icon:hover {\n        color: #5865c3;\n      }\n    }\n\n    .chat-logs {\n      padding: 0;\n      height: 300px;\n\n      .chat-msg {\n        margin-bottom: 5px;\n\n        .chat-text-div {\n          display: flex;\n        }\n\n        .timestamp {\n          float: right;\n          font-size: 12px;\n          padding: 5px 10px;\n          color: black;\n        }\n\n        .user-name {\n          display: flex;\n          justify-content: space-between;\n          width: 100%;\n        }\n        .user-details{\n          display: flex;\n          .user-icon{\n            width: 40.79px;\n            height: 40px;\n            gap: 0px;\n            border-radius: 100px 0px 0px 0px;\n            opacity: 0px;\n          }\n        }\n\n        .user-name-details {\n          font-weight: 400;\n          text-align: start;\n          font-size: 12px;\n          display: flex;\n          flex-direction: column;\n          margin-left: 5px;\n          .user-name-display{\n            font-size: var(--font-size-md);\n            font-weight: 700;\n            line-height: 24px;\n          }\n        }\n\n        .details {\n          font-size: 12px;\n          margin-left: 35px;\n          color: #999;\n          .time {\n            margin-left: 7rem;\n          }\n        }\n\n        .user-chat {\n          align-items: center;\n          line-height: 1.75;\n          display: inline-flex;\n          width: 100%;\n          border-radius: 3px;\n          white-space: pre-wrap;\n          font-weight: 400;\n          font-size: var(--font-size-md);\n          overflow-wrap: anywhere;\n        }\n      }\n    }\n\n    .chat-logs-expand {\n      height: 380px;\n    }\n\n    .chat-logs::-webkit-scrollbar-track {\n      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n      background-color: #f5f5f5;\n    }\n\n    .chat-logs::-webkit-scrollbar {\n      width: 5px;\n      background-color: #f5f5f5;\n    }\n\n    .chat-logs::-webkit-scrollbar-thumb {\n      background-color: #5a5eb9;\n    }\n\n    @media only screen and (max-width: 500px) {\n      .chat-logs {\n        height: 40vh;\n      }\n    }\n\n    .cm-msg-text {\n      background: white;\n      padding: 10px 15px 10px 15px;\n      color: #666;\n      max-width: 75%;\n      float: left;\n      margin-left: 10px;\n      position: relative;\n      margin-bottom: 20px;\n      border-radius: 30px;\n    }\n\n    .chat-msg {\n      clear: both;\n    }\n\n    .chat-msg.self>.cm-msg-text {\n      float: right;\n      margin-right: 10px;\n      background: #5a5eb9;\n      color: var(--color-white);\n    }\n\n    .cm-msg-button>ul>li {\n      list-style: none;\n      float: left;\n      width: 50%;\n    }\n\n    .cm-msg-button {\n      clear: both;\n      margin-bottom: 70px;\n    }\n\n    .editSection {\n      display: flex;\n      border-radius: 3px;\n      font-weight: 400;\n      font-size: var(--font-size-md);\n      line-height: 24px;\n      span {\n        margin-left: 2px;\n        padding: 2px;\n        cursor: pointer;\n      }\n    }\n\n    .message {\n      display: flex;\n      justify-content: space-between;\n      margin-bottom: 5px;\n    }\n\n    .hkNbke {\n      border: solid 1px var(--table-input-border-color) !important;\n      border-bottom: solid 2px #0dcaf0 !important;\n    }\n\n    .comment-editors {\n      display: flex;\n      align-items: center;\n      background-color: #f9f9f9;\n      padding: 5px;\n      border-radius: 5px;\n\n      .text-area-comment {\n        flex: 1;\n        padding: 2px;\n        border-radius: 4px;\n        outline: none;\n      }\n\n      .hkNbke {\n        border: solid 1px var(--table-input-border-color) !important;\n        border-bottom: solid 2px #0dcaf0 !important;\n      }\n      \n    }\n\n    .edit-icon {\n      color: var(--color-maersk-blue);\n      cursor: pointer;\n      .edit-image{\n        height: 18px;\n      }\n    }\n    .notes-button{\n      margin-top: -3px;\n    }\n\n    .edit-icon :hover {\n      color: #466b77;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
